import React, { useState } from "react"

import { Container, CustomerClientInfo, Logo, LogoInvisiblePlaceholder, LogoContainer } from "./styles"

import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Button from "@material-ui/core/Button"
import MenuItem from "@material-ui/core/MenuItem"
import Typography from "@material-ui/core/Typography"
import Divider from "@material-ui/core/Divider"
import Avatar from "@material-ui/core/Avatar"
import Menu from "@material-ui/core/Menu"
import IconButton from "@material-ui/core/IconButton"

import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"
import ArrowBackIcon from "@material-ui/icons/ArrowBack"
import ShareOutlinedIcon from "@material-ui/icons/ShareOutlined"

import { useHomeState } from "../../store/home"

import { useNavigation } from "../../services/navigation"
import api from "../../services/api"
import { logout } from "../../services/auth"

import useDefaultStyles from "../../styles/default"

import ShareMenuModal from "../../components/ShareDialog/Dialogs/ShareMenuModal"

const Navbar = () => {
	const homeState = useHomeState()

	const { getRouteParams, navigate, getPathName } = useNavigation()

	const { hash } = getRouteParams()
	const pathname = getPathName()

	const [anchorElement, setAnchorElement] = useState(null)

	const defaultClasses = useDefaultStyles()

	const handleLogout = async () => {
		setAnchorElement(null)
		await api.get("/home/logout").catch(() => {})
		logout()
	}

	const mainRoute = pathname === `/${hash}`
	const blackListPages = ["reset-password"]
	const isPageOnBlackList = blackListPages.some(page => pathname.includes(page))

	const hasReturnIcon = !mainRoute && !isPageOnBlackList

	if (pathname.includes("request-recovery") || pathname.includes("reset-password")) {
		return (
			<Container hasReturnIcon={hasReturnIcon}>
				{hasReturnIcon && (<IconButton onClick={() => navigate(`/${hash}`)} style={{ marginRight: 10 }}>
						<ArrowBackIcon />
					</IconButton>
				)}

				{homeState.customer.logo ? (
					<LogoContainer>
						<Logo src={homeState.customer.logo} alt="logo" />
					</LogoContainer>
				) : (
					<LogoInvisiblePlaceholder />
				)}
			</Container>
		)
	}

	return (
		<Container hasReturnIcon={hasReturnIcon}>
			{hasReturnIcon && (<IconButton onClick={() => navigate(`/${hash}`)} style={{ marginRight: 10 }}>
					<ArrowBackIcon />
				</IconButton>
			)}

			{homeState.customer.logo ? (
				<LogoContainer>
					<Logo src={homeState.customer.logo} alt="logo" />
				</LogoContainer>
			) : (
				<LogoInvisiblePlaceholder />
			)}

			<IconButton onClick={() => {
				ShareMenuModal.open(homeState.front.home_url)
			}}>
				<ShareOutlinedIcon />
			</IconButton>

			{homeState.client && (
				<CustomerClientInfo>
					<Avatar>{homeState.client.name.slice(0, 1).toUpperCase()}</Avatar>

					<Divider
						orientation="vertical"
						className={defaultClasses.invisibleVerticalDividerSmall}
					/>

					<Typography variant="subtitle2">
						{homeState.client.name
							.split(" ")
							.slice(0, 2)
							.join(" ")}
					</Typography>

					<IconButton
						aria-label="more"
						aria-controls="customer-client-menu"
						aria-haspopup="true"
						onClick={({ currentTarget }) => setAnchorElement(currentTarget)}
					>
						<ExpandMoreIcon />
					</IconButton>

					<Menu
						id="customer-client-menu"
						anchorEl={anchorElement}
						keepMounted
						open={!!anchorElement}
						onClose={() => setAnchorElement(null)}
						PaperProps={{
							style: {
								marginTop: 45
							}
						}}
					>
						<MenuItem onClick={() => handleLogout()}>
							<ListItemIcon style={{ minWidth: 35 }}>
								<ExitToAppIcon fontSize="small" />
							</ListItemIcon>
							<ListItemText primary="Sair" />
						</MenuItem>
					</Menu>
				</CustomerClientInfo>
			)}

			{!homeState.client && (
				<Button
					style={{ marginRight: 20 }}
					onClick={() => navigate(`/${hash}/login`, { keepQueryParams: true })}
				>
					<Typography variant="subtitle2">Entrar</Typography>
				</Button>
			)}
		</Container>
	)
}

export default Navbar